import Image from "next/image";
import React, { useEffect } from "react";
import LazyLoad from "react-lazy-load";
import { useToast } from "../../../context/toastContext";

export const About = ({ data, error }) => {
  const toast = useToast();

  useEffect(() => {
    if (error) toast("error", error);
  }, [error]);

  return (
    !error && (
      <div>
        <h1 className="text-xl md:text-3xl font-light w-full leading-1 font-bold">
          About
        </h1>
        <h2 className="text-xl mb-4">Vinous</h2>
        <p>{data?.about_info?.description}</p>
        <h2 className="text-xl mb-4 mt-4">Team</h2>
        <div className="flex flex-wrap xs:flex-col sm:flex-row lg:flex-row">
          {data?.team?.map(
            (member, index) =>
              member.active && (
                <div
                  className="group rounded overflow-hidden shadow-lg mb-8 xs:w-full md:w-1/2 hover:shadow-2xl transition duration-500 ease-in-out transform hover:-translate-y-1 "
                  key={index}
                >
                  <LazyLoad
                    threshold={0.95}
                    className="flex justify-center overflow-hidden translate3d backface-hidden "
                  >
                    <Image
                      src={member.photo_url}
                      alt={member.name}
                      className="object-contain rounded-full filter grayscale group-hover:grayscale-0 transition duration-500"
                      width={200}
                      height={200}
                      sizes="100vw"
                    />
                  </LazyLoad>

                  <div className="px-6 py-4 mb-4">
                    <div className="flex flex-col justify-center items-center">
                      <div className="font-bold text-xl mb-2">
                        {member.name}
                      </div>
                      <div className="text-red font-bold mb-4">
                        {member.title}
                      </div>
                    </div>

                    <div
                      className={`text-gray-700 text-base xs:h-full md:h-full xl:h-96 2xl:80`}
                      dangerouslySetInnerHTML={{ __html: member.bio }}
                    ></div>
                  </div>
                  {member.regions_covered && (
                    <div className="px-6 pt-4 pb-2">
                      <strong>Regions covered: </strong>
                      {member.regions_covered}
                    </div>
                  )}
                </div>
              )
          )}
        </div>
      </div>
    )
  );
};
